// extracted by mini-css-extract-plugin
export default {"cls1":"Stats-cls1__cd0a4ac6058f121f9fe1","cls2":"Stats-cls2__ed62435f839783b2ee0e Stats-cls1__cd0a4ac6058f121f9fe1"};